<script setup>
import { useStore } from "vuex";

const props = defineProps({
  errors: {
    type: Array,
    required: true
  }
});

const store = useStore();

const handleClearError = index => {
  store.commit("errors/clearErrorByIndex", index);
};
</script>

<template>
  <div class="error-handler">
    <div class="error-handler__list">
      <div v-for="(error, index) in props.errors" :key="index" class="error-handler__item">
        <div class="error-handler__item-title-wrapper">
          <div class="error-handler__item-title">
            {{ error.title }}
          </div>

          <button class="error-handler__item-clear" @click="handleClearError(index)">
            Clear this error
          </button>
        </div>

        <div class="error-handler__item-error">
          {{ error.error }}
        </div>

        <dl
          v-for="(details, detailsIndex) in error.details"
          :key="detailsIndex"
          class="error-handler__item-details"
        >
          <dt class="error-handler__item-details-title">
            {{ details.title }}
          </dt>

          <dd class="error-handler__item-details-description">
            {{ details.description }}
          </dd>
        </dl>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import "frontend/init/pod/settings";
@import "frontend/init/jiffy/button/mixin";

.error-handler {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 20px;

  &__list {
    border-radius: 10px;
    max-width: 600px;
    margin: 0 auto;
    background-color: $pod-danger;
    color: $white;
    padding: 16px;
  }

  &__item {
    & + & {
      padding-top: 10px;
      margin-top: 10px;
      border-top: 1px solid currentColor;
    }
  }

  &__item-title-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__item-title {
    font-size: 16px;
    font-weight: bold;
  }

  &__item-clear {
    @include clear-button;

    border: 2px solid;
    border-radius: 6px;
    padding: 2px 4px;
    font-size: 12px;
    font-weight: bold;
  }

  &__item-details {
    display: flex;
    margin-top: 2px;
    font-size: 13px;
  }

  &__item-details-title {
    font-weight: 600;
    margin-right: 5px;
  }
}
</style>
